import { render, staticRenderFns } from "./PlaytimeEnded.vue?vue&type=template&id=5d937f6c&scoped=true&"
import script from "./PlaytimeEnded.vue?vue&type=script&lang=js&"
export * from "./PlaytimeEnded.vue?vue&type=script&lang=js&"
import style0 from "./PlaytimeEnded.vue?vue&type=style&index=0&id=5d937f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d937f6c",
  null
  
)

export default component.exports